module.exports = __webpack_public_path__ + "static/data_image.41a7e891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data_image.jpg
// module id = 594
// module chunks = 135035368556471